//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiProgress from "../../components/cancel_plan/Progress";
import { mapGetters } from "vuex";
import { cancel, sendFeedback } from "../../services/payment";
import { showErrorMsg } from "../../utils/error";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_USER_PLAN_LIST_SIMPLE,
} from "../../store/mutation-types";
export default {
  name: "CancelDetailPage",
  components: { HiHeader, HiProgress },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
    }),
    unsubscription() {
      return this.user.unsubscription;
    },
    banner() {
      // 如果存在优惠则显示offer，不存在则直接显示detail
      const list = [
        { text: "Feedback", active: true },
        { text: "Detail", active: true },
      ];
      if (this.unsubscription) {
        list.push({ text: "Offer", active: false });
      }
      return list;
    },
    currentPlanDes() {
      const current = this.user.plan.cancelInfo;
      if (current) {
        const des = current.desc.replace(/✓/g, "✗");
        const desArr = des.split("\n");
        let result = [];
        desArr.forEach((row) => {
          const iconIndex = [...row].findIndex((r) => r === "✓" || r === "✗");
          result.push({
            icon: row.substr(0, iconIndex + 1).trim(),
            // eslint-disable-next-line
            text: row
              .substr(iconIndex + 1)
              .replace(/  /g, "")
              .trim(), // 玄学过滤 千万不要动，否则pt语言会有问题
            forbid: [...row].findIndex((r) => r === "✗") !== -1,
          });
        });
        return result;
      }
      return [];
    },
  },
  methods: {
    async closeClick() {
      try {
        this.$loading.show();
        await sendFeedback({ feedback: this.$route.query.feedback });
        this.$router.go(-2);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    async cancelClick() {
      try {
        this.$loading.show();
        await cancel({ feedback: this.$route.query.feedback });
        this.$router.push({
          name: "PaymentHistoryPage",
          query: { back: "plan" },
        });
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    nextClick() {
      // 验证feedback是否已经输入
      this.$router.push({ name: "CancelOfferPage", query: this.$route.query });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/cancel_plan/Detail.vue